
const { REACT_APP_RESOLVER_URL } = process.env;

const returnQRCodeParameters = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const domain = urlParams.get("domain");
    let resAddr = `${REACT_APP_RESOLVER_URL}`;

    if (typeof (domain) === "string" && domain !== "") resAddr = "https://" + domain;

    const fragments = window.location.pathname.split("/");
    // check if request is for type text, sms, email etc.
    const type = fragments[fragments.length - 2];
    // id of the qrcode short_url (https://short_base_url/type/id)
    const id = fragments[fragments.length - 1].split('?')[0];

    return {...{resAddr, type, id}}
}

export { returnQRCodeParameters }